export enum FeeManagementSuccessCodes {
  FEE_RETRY_SUCCESSFUL = 'retry_successful',
  FEE_REVERT_SUCCESSFUL = 'revert_successful',
  FEE_CHARGE_APPLIED = 'fee_charge_applied',
}
